// components/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useContext(AuthContext);

    if (!isAuthenticated) {
        // User is not authenticated, redirect to login page
        return <Navigate to="/" replace />;
    }

    // User is authenticated, render the requested component
    return children;
};

export default ProtectedRoute;